// src/contexts/PromoCodeContext.jsx
import { createContext, useContext, useState } from "react";
import { BASE_URL } from "../config/config";

const PromoCodeContext = createContext();

export const PromoCodeProvider = ({ children }) => {
  const [promo, setPromo] = useState(null);
  const [error, setError] = useState(null);

  const applyPromoCode = async (code, totalAmount, token) => {
    try {
      const res = await fetch(`${BASE_URL}/client/promocode/apply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ code, total_amount: totalAmount }),
      });
      const data = await res.json();
      if (res.ok) {
        setPromo(data.data);
        setError(null);
        return data.data;
      } else {
        throw new Error(data.message || "Invalid promo code");
      }
    } catch (err) {
      setPromo(null);
      setError(err.message);
    }
  };

  const clearPromo = () => setPromo(null);

  return (
    <PromoCodeContext.Provider value={{ promo, error, applyPromoCode, clearPromo }}>
      {children}
    </PromoCodeContext.Provider>
  );
};

export const usePromoCode = () => useContext(PromoCodeContext);
    